import { Component, computed, input } from '@angular/core';
import { EmptyClass, EventInfo, getDefaultTimeZoneForCountry, TimeZoneRegion } from 'in-time-core';
import { LocalizationMixinSignals } from '../../../core/mixins/localization-mixin-signal';
import { RouterModule } from '@angular/router';
import { StartDateComponent } from '../start-date/start-date.component';
import { LocationInfoComponent } from '../location-info/location-info.component';
import { getActiveAppFlavor } from '../../../app.flavors';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [
    CommonModule, RouterModule, StartDateComponent, LocationInfoComponent,
  ],
  selector: 'app-small-event-card',
  templateUrl: './small-event-card.component.html',
})
export class SmallEventCardComponent extends LocalizationMixinSignals(EmptyClass) {
  public readonly event = input.required<EventInfo>();
  public readonly canOverrideEventLink = input<boolean>();

  public readonly name = computed(() => {
    return this.getLocalizedText(this.event().localizedName) ?? '?';
  });

  public readonly timezone = computed(() => {
    const timezoneOfEvent = getDefaultTimeZoneForCountry(this.event().country);

    return timezoneOfEvent ?? TimeZoneRegion.EuropeBudapest;
  });


  public readonly eventWebRoute = computed(() => {
    const flavor = getActiveAppFlavor();
    return `${flavor.eventRoutePrefix}${this.event().webRoute}`;
  });

  public readonly eventLinkOverride = computed(() => {
    return (this.canOverrideEventLink() ?? false) ? this.event().passEventOverrideLink : null;
  });
}
